var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.imageSwapperStyleObject),on:{"click":_vm.swapImages}},[_vm._v(_vm._s(_vm.swapImagesButton))])
}
var staticRenderFns = []

export { render, staticRenderFns }